import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@thkStore/Store/Pages/Cart/Handlers/UpdateCartLine"
import "@thkStore/Store/Pages/ProductDetails/Handlers/CustomDisplayProduct";
import "@thkStore/Store/Pages/ProductDetails/Handlers/CustomLoadProductByPath";
import "@thkStore/Store/Pages/ProductDetails/Handlers/CustomLoadVariantChildren";
import "@thkStore/Store/Reducers";
import "@thkStore/Store/Widgets/Clipboard/Handlers";
import "@thkStore/Store/Widgets/IncludeProducts/Handlers";
// import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn|Cart|ClipboardSummary|ContactUs|ProductDetails|ProductList|VariantChildrenGrid|FooterScriptInjector|ExemptionCertificateWizard|ExemptionCertificateList|Category|Catalog)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { postTheme } from "@thkStore/theme/post";
import { preTheme } from "@thkStore/theme/pre";
import{ importWidgetExtensions } from "@thkStore/WidgetExtensions/importWidgetExtensions";

// Load only the required widget extensions.
importWidgetExtensions;

// Pre customization layer with styles that the CMS can modify
setPreStyleGuideTheme(preTheme);

// Post customization layer with styles that the CMS cannot change
setPostStyleGuideTheme(postTheme);
